import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './globals.css';

// The HTML is prerendered at build time (see prerender.mjs), so we hydrate
// the existing markup rather than rendering from scratch.
hydrateRoot(
  document.getElementById('root')!,
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
